export const MODULE_NAME = 'signalR';
